<template>
  <div>
    <div class="event-banner col px-0">
      <div
        class="carousel-2 slider"
        id="carousel-2"
        v-if="banner !== undefined"
        v-show="showSlide"
      >
        <div v-for="b in banner" :key="b.bannerImg">
          <img
            :src="getBannerImg(b.bannerImg)"
            class="rounded fixed-banner-height center"
            @click="bannerLink(b.url)"
            data-toggle="tooltip"
            data-placement="bottom"
            :title="b.hint"
          />
        </div>
      </div>
    </div>

    <!-- 新增的區塊，點擊後導向 IframeDisplay.vue -->
    <!-- <div
      class="new-iframe-block"
      @click="goToIframePage"
      style="
        cursor: pointer;
        background: #f0f0f0;
        padding: 15px;
        margin-top: 20px;
      "
    >
      <p style="text-align: center; font-weight: bold">點擊此處查看外部網站</p>
    </div> -->
  </div>
</template>
<script setup>
import { useUserInfoStore } from "@/store/modules/userInfo";
import { computed, onMounted, onUpdated, watch } from "@vue/runtime-core";
import { useGlobalStore } from "@/store/modules/global";
import { useRouter } from "vue-router";

const userInfo = useUserInfoStore();
const router = useRouter();

const FunEvent = computed(() => {
  return new URL(`../assets/img/FUN-EVENT.png`, import.meta.url).href;
});
const MSUBN = computed(() => {
  return new URL(`../assets/img/MSU-BN.png`, import.meta.url).href;
});
const ComingSoon = computed(() => {
  return new URL(`../assets/img/Coming-Soon.png`, import.meta.url).href;
});
const props = defineProps({
  loadingFinish: {
    type: Boolean,
    default: () => false,
  },
});
const showSlide = ref(true); // 改為 true，讓 banner 預設顯示
const bannerLink = (url) => {
  window.open(url, "_blank");
};
const getBannerImg = (url) => {
  return `${import.meta.env.VITE_CLiENT_DOMAIN}${url}`;
};
onUpdated(() => {
  $(".carousel-2")
    .not(".slick-initialized")
    .slick({
      dots: true,
      infinite: true,
      speed: 1000,
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 6000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
});
const institution = ref();
const banner = computed(() => {
  return JSON.parse(JSON.stringify(userInfo.institution)).banner;
});
onMounted(() => {
  institution.value = JSON.parse(JSON.stringify(userInfo.institution));
});
watch(
  () => props.loadingFinish,
  (val, oldVal) => {
    showSlide.value = true;
    // loadCarousel();
  }
);
// const loadCarousel = () => {
//   console.log("loadCarousel");
//   $(".carousel-2")
//     .not(".slick-initialized")
//     .slick({
//       dots: true,
//       infinite: true,
//       speed: 300,
//       slidesToShow: 2,
//       slidesToScroll: 2,
//       autoplay: true,
//       autoplaySpeed: 2500,
//       responsive: [
//         {
//           breakpoint: 1024,
//           settings: {
//             slidesToShow: 2,
//             slidesToScroll: 2,
//             infinite: true,
//           },
//         },
//         {
//           breakpoint: 600,
//           settings: {
//             slidesToShow: 2,
//             slidesToScroll: 2,
//           },
//         },
//         {
//           breakpoint: 480,
//           settings: {
//             slidesToShow: 1,
//             slidesToScroll: 1,
//           },
//         },
//       ],
//     });
// };

// 新增：點擊區塊後使用 router 導向新的頁面
const goToIframePage = () => {
  router.push({ name: "IframeDisplay" });
};
</script>
<style lang="scss" scoped>
figure,
img {
  max-width: 100% !important;
  height: auto;
  vertical-align: middle;
}

// .fixed-banner-height {
//   height: 190px;
// }

.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.slick-slide {
  margin: 0px 0px !important;
}

/* 新增區塊的額外樣式 */
.new-iframe-block {
  border: 1px solid #ccc;
  border-radius: 4px;
}
</style>
